<template>
  <v-autocomplete
    hide-details="auto"
    :items="OrderType"
    :loading="loading"
    v-model="selectedOrderType"
    item-text="name"
    item-value="id"
    label="Order Type"
    clearable
    multiple
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchOrderType"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    OrderType: [
      {
        id: 'dine_in',
        name: "Dine In",
      },
      { id: 'take_away', name: "Take Away" },
      // { id: 'delivery', name: "Delivery" },
      { id: 'service_order', name: "Service Order" },
    ],
    selectedOrderType: [],
    searchOrderType: null,
    loading: false,
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedOrderType);
    },
    //     getOrderTypeByQuery(query = "") {

    //       this.loading = true;
    //       this.$store
    //         .dispatch("OrderType/GetOrderTypes", {
    //           query: query,
    //           status: "active",
    //         })
    //         .then((res) => {
    //           this.OrderType = res.data.data
    //           this.loading = false;

    //         })
    //         .catch((err) => {
    //           this.loading = false;
    //         });
    //     },
  },
  watch: {
    clear: {
      handler() {
        this.selectedOrderType = [];
      },
    },
  },
};
</script>